import { ROOT_URL } from '../actions';

export const authApi = {
  LOGIN: `${ROOT_URL}/auth/login/`,
  PROFILE: `${ROOT_URL}/auth/profile/`,
  GET_VALID_SCAN_TYPES: `${ROOT_URL}/hms/get_valid_scan_types/`
}